module.exports = {"name":"app version","version":113}


//////////////////
// WEBPACK FOOTER
// ./static/version.json
// module id = 27
// module chunks = 1